import {Component, Inject, OnDestroy, ChangeDetectionStrategy} from '@angular/core';
import {JobPosting} from "../gather-typings";
import {Subscription} from "rxjs";
import {SharedDataService} from "../gather-services/shared-data.service";
import {EnvironmentToken} from "../../../util";
import {Environment} from "../../../typings";

@Component({
    selector: 'app-already-a-talent',
    templateUrl: './already-a-talent.component.html',
    styleUrls: ['./already-a-talent.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AlreadyATalentComponent implements OnDestroy{
  jobPosting: JobPosting;
  subscriptions = new Subscription();
  constructor(private sharedDataService: SharedDataService,
              @Inject(EnvironmentToken) private environment: Environment) {
    this.subscriptions.add(
      this.sharedDataService.jobPosting.subscribe(posting => {
        this.jobPosting = posting;
      })
    );
  }

  goToJobCenter(): void {
    top.location.replace(`${this.environment.matHost}/myaquent?PROC=AWUIDrawAdvancedJobSearch`);
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
